const STYLE_ID = 'rqd-trigger-styles'

const TRIGGER_CSS = `
.rqd-trigger {
  -webkit-appearance: none;
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: var(--rqd-radius, 6px);
  border: 1px solid transparent;
  font-family: var(--rqd-font, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  background: var(--rqd-primary, #0F5E56);
  color: #fff;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;
  user-select: none;
}
.rqd-trigger:hover { filter: brightness(1.06); }
.rqd-trigger:active { transform: translateY(1px); }
.rqd-trigger:focus-visible {
  outline: 2px solid var(--rqd-primary, #0F5E56);
  outline-offset: 2px;
}
.rqd-trigger svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  fill: currentColor;
}
.rqd-trigger--pill {
  border-radius: 999px;
  padding: 8px 18px;
}
.rqd-trigger--ghost {
  background: transparent;
  color: var(--rqd-primary, #0F5E56);
  border-color: var(--rqd-primary, #0F5E56);
}
.rqd-trigger--ghost:hover {
  background: color-mix(in srgb, var(--rqd-primary, #0F5E56) 12%, transparent);
}
.rqd-trigger--icon {
  padding: 8px;
  width: 36px;
  height: 36px;
  border-radius: 999px;
}
.rqd-trigger--icon .rqd-trigger-label {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
`

export function injectTriggerStyles(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = TRIGGER_CSS
  document.head.appendChild(style)
}
